import * as i0 from '@angular/core';
import { DestroyRef, inject, ChangeDetectorRef, Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

class ErrorComponent {
    constructor() {
        this.show = true;
        this.destroyRef = inject(DestroyRef);
        this.ngControl = inject(NgControl, { optional: true });
        this.cdr = inject(ChangeDetectorRef);
    }
    ngOnInit() {
        if (!this.validatorName) {
            return;
        }
        this.show = this.ngControl?.errors?.[this.validatorName] ?? false;
        this.ngControl?.statusChanges?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            if (!this.validatorName) {
                return;
            }
            this.show = this.ngControl?.errors?.[this.validatorName] ?? false;
            this.cdr.markForCheck();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: ErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: ErrorComponent, isStandalone: true, selector: "kb-error", inputs: { validatorName: "validatorName" }, host: { properties: { "class.kb-show": "this.show" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:none}:host.kb-show{display:inline}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: ErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-error', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [], template: "<ng-content></ng-content>\n", styles: [":host{display:none}:host.kb-show{display:inline}\n"] }]
        }], propDecorators: { validatorName: [{
                type: Input
            }], show: [{
                type: HostBinding,
                args: ['class.kb-show']
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorComponent };
